export const CURRENT_USER_QUERY_KEY = ['currentUser'] as const;
